import { z } from 'zod';
import { permissionSchema, roleSchema } from './permissions.js';
/** Password policy (see DECISIONS.md): 10-128 chars, at least one letter and one digit. */
export const PASSWORD_MIN_LENGTH = 10;
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Password must be at least ${PASSWORD_MIN_LENGTH} characters`)
    .max(128, 'Password must be at most 128 characters')
    .refine((v) => /\p{L}/u.test(v), 'Password must contain at least one letter')
    .refine((v) => /\d/.test(v), 'Password must contain at least one digit');
export const AUTH_CLIENTS = ['web', 'mobile'];
export const deviceIdSchema = z
    .string()
    .min(8)
    .max(128)
    .regex(/^[A-Za-z0-9._:-]+$/, 'Invalid device id');
export const loginRequestSchema = z
    .object({
    phoneNumber: z.string().min(1).max(32),
    password: z.string().min(1).max(256),
    client: z.enum(AUTH_CLIENTS),
    /** Required for mobile; web sessions use a per-browser id generated server-side. */
    deviceId: deviceIdSchema.optional(),
    deviceName: z.string().max(100).optional(),
    /** What the platform allows us to know about the phone (D93). Optional: older apps do not send it. */
    device: z
        .object({
        platform: z.enum(['android', 'ios', 'web', 'unknown']).optional(),
        model: z.string().max(100).nullable().optional(),
        manufacturer: z.string().max(100).nullable().optional(),
        osVersion: z.string().max(50).nullable().optional(),
        appVersion: z.string().max(40).nullable().optional(),
        buildFingerprint: z.string().max(300).nullable().optional(),
    })
        .optional(),
})
    .refine((v) => v.client !== 'mobile' || Boolean(v.deviceId), {
    message: 'deviceId is required for mobile clients',
    path: ['deviceId'],
});
export const authUserSchema = z.object({
    id: z.string(),
    phoneNumber: z.string(),
    fullName: z.string(),
    role: roleSchema,
    permissions: z.array(permissionSchema),
});
export const tokenResponseSchema = z.object({
    accessToken: z.string(),
    accessTokenExpiresAt: z.string(),
    /** Only returned to mobile clients. Web clients receive it as an httpOnly cookie. */
    refreshToken: z.string().optional(),
    refreshTokenExpiresAt: z.string(),
    user: authUserSchema,
    /** Mobile only: how the server sees this phone (D93). PENDING still works; the admin is alerted. */
    device: z.object({ status: z.enum(['APPROVED', 'PENDING', 'REJECTED']), isNew: z.boolean() }).optional(),
});
export const refreshRequestSchema = z.object({
    /** Mobile sends the token in the body; web relies on the httpOnly cookie. */
    refreshToken: z.string().min(20).max(512).optional(),
});
export const logoutRequestSchema = refreshRequestSchema;
export const meResponseSchema = z.object({ user: authUserSchema });
//# sourceMappingURL=auth.js.map